import axiosInstance from "./api_helper";

const BASE_URL = "/api/inventaires";

const inventoryService = {

  // 🔍 SEARCH Inventories (pagination + filters)
  search: (params) => {
    console.log(params)
    return axiosInstance.get(BASE_URL, { params });
    /*
      params example:
      {
        page: 0,
        size: 10,
        dateFrom: "2026-01-01",
        dateTo: "2026-01-31",
        entrepotId: 1,
        status: "BROUILLON"
      }
    */
  },

  // 📄 GET one inventory
  getById: (id) => {
    return axiosInstance.get(`${BASE_URL}/${id}`);
  },

  // ➕ CREATE inventory
  searchLines: (id, params) => {
    return axiosInstance.get(`${BASE_URL}/${id}/lignes`, { params });
  },

  create: (data) => {
    return axiosInstance.post(BASE_URL, data);
    /*
      data = {
        dateInventaire: "2026-01-28",
        entrepotId: 1,
        lignes: [
          {
            articleId: 10,
            quantiteTheorique: 5,
            quantitePhysique: 7
          }
        ]
      }
    */
  },

  // ✏️ UPDATE inventory (only if BROUILLON)
  update: (id, data) => {
    return axiosInstance.put(`${BASE_URL}/${id}`, data);
  },

  // ❌ DELETE inventory
  delete: (id) => {
    return axiosInstance.delete(`${BASE_URL}/${id}`);
  },

  // ✅ VALIDATE inventory → triggers stock adjustment
  validate: (id) => {
    return axiosInstance.post(`${BASE_URL}/${id}/validate`);
  }

};

export default inventoryService;

